/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-01 13:52:54
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-12 11:19:31
 */
const parentRouter = [
  {
    label: '权限管理',
    path: ''
  }
]
const routes = [
  {
    path: '/authManage/menu',
    name: 'menu',
    meta: {
      icon: 'icon-renyuanguanli',
      title: '菜单管理',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/auth/views/Menu.vue')
  },
  {
    path: '/authManage/role',
    name: 'role',
    meta: {
      icon: 'icon-renyuanguanli',
      title: '角色管理',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/auth/views/Role.vue')
  },
  {
    path: '/authManage/role/authorization',
    name: 'roleAuth',
    meta: {
      icon: 'icon-renyuanguanli',
      title: '角色权限',
      keepAlive: false,
      parentTitle: [...parentRouter, { label: '角色管理', path: '/authManage/role' }]
    },
    component: () => import('@main/modules/auth/components/roleAuthorization.vue')
  },
  {
    path: '/authManage/interface',
    name: 'interface',
    meta: {
      icon: 'icon-renyuanguanli',
      title: '接口管理',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/auth/views/Interface.vue')
  }
]
export default routes
